import { type FC, type MouseEvent, type ReactNode } from "react";

import { Modal } from "@snapchat/snap-design-system";

import { type ModalProps } from "../hooks/useToggleState";

import { ModalCloseButton } from "./ModalCloseButton";

interface ClosableModalProps {
    modalProps: ModalProps;
    height?: number;
    width?: number | "auto";
    className?: string;
    children?: ReactNode;
}

export const ClosableModal: FC<ClosableModalProps> = ({ modalProps, className, width, children }) => {
    return (
        <Modal {...modalProps} padBody={true} footer={false} width={width} className={className}>
            <div>
                <ModalCloseButton
                    onClick={(event: MouseEvent<HTMLElement>) => {
                        modalProps.onCancel();
                        event.stopPropagation();
                    }}
                />
                {children}
            </div>
        </Modal>
    );
};
